import { v4 } from "uuid";
import { SHA256 } from "crypto-js";
import { MsalAuthenticationServiceImplementation } from "../msal/msal-authentication-service";

export class SdControllerUtilities {
  // @ngInject
  constructor(private msalAuthenticationService: MsalAuthenticationServiceImplementation) {}

  public getParametersForUserCacheBusting(): any {
    let uniqueIdentifer: string;
    if (this.msalAuthenticationService.userInfo.isAuthenticated) {
      uniqueIdentifer = this.msalAuthenticationService.userInfo.idToken.preferred_username;
    } else {
      uniqueIdentifer = v4();
    }

    let config: ng.IRequestShortcutConfig = {
      params: {
        u: SHA256(uniqueIdentifer).toString()
      }
    };

    return config;
  }
}
